import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled from 'styled-components';
var StyledModalScrollFooter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n  margin-bottom: -8px;\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n  margin-bottom: -8px;\n"])));
var ModalScrollFooter = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement(StyledModalScrollFooter, { className: className }, children);
};
export default ModalScrollFooter;
var templateObject_1;
//# sourceMappingURL=ModalScrollFooter.js.map